import { ParticleService } from "appworks/graphics/particles/particle-service";
import { ParticleContainer } from "appworks/graphics/pixi/particle-container";
import { Services } from "appworks/services/services";
import { Timer } from "appworks/utils/timer";
import { Tween } from "appworks/utils/tween";
import { gameLayers } from "game-layers";
import { BigWinComponent } from "slotworks/components/bigwin/big-win-component";
import { ApplyFowlPlayTextStyling } from "util/fowl-text-style";

export class FowlBigWinComponent extends BigWinComponent {
    public init(): void {
        super.init();
        gameLayers.CelebrationContent.onSceneEnter.add((scene: keyof typeof gameLayers.CelebrationContent.scene) => this.onSceneEnter(scene));
    }

    protected onSceneEnter(scene: keyof typeof gameLayers.CelebrationContent.scene) {
        const { CelebrationContent } = gameLayers;

        if (scene !== "megawin" && scene !== "superwin" && scene !== "bigwin" && scene !== "win") {
            return;
        }

        const { chicken, label, value } = CelebrationContent.scene[scene].contents;

        // queue up idle animation on chicken after transition
        const timeScale = 0.75;
        chicken.spines.landscape.state.addAnimation(0, "idle", true, 0).timeScale = timeScale;
        chicken.spines.portrait.state.addAnimation(0, "idle", true, 0).timeScale = timeScale;

        // set up particle emitter
        const particles = new ParticleContainer();
        Services.get(ParticleService).add("CelebrationEggs", particles);
        Services.get(ParticleService).add("CelebrationFeathers", particles);

        // add to the stage
        CelebrationContent.add(particles, undefined, true);

        // set emitter position
        const particlePosition = CelebrationContent.scene[scene].contents.positions.particles;
        particles.dualPosition.setPosition(particlePosition);
        particles.dualPosition.landscape.x += particlePosition.landscape.width / 2;
        particles.dualPosition.landscape.y += particlePosition.landscape.height / 2;
        particles.dualPosition.portrait.x += particlePosition.portrait.width / 2;
        particles.dualPosition.portrait.y += particlePosition.portrait.height / 2;

        // start emitter once chicken begins to idle
        particles.emitter.emit = false;
        let { duration } = chicken.getAnimations()[chicken.getAnimationIndex()];
        duration *= 1000;
        Timer.setTimeout(() => {
            particles.emitter.emit = true;
        }, duration);

        // scale in the labels
        const positions = [label.landscape, label.portrait, value.landscape, value.portrait];
        for (const position of positions) {
            position.scale.set(0);
            new Tween(position.scale).to({ x: 1, y: 1 }, duration).start();
        }

        ApplyFowlPlayTextStyling(label, 4);
    }
}
